var i = Object.defineProperty;
var m = (t, e, r) => e in t ? i(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var s = (t, e, r) => (m(t, typeof e != "symbol" ? e + "" : e, r), r);
import { constructFrom as p } from "../../../constructFrom.js";
import { Parser as a } from "../Parser.js";
import { parseAnyDigitsSigned as n } from "../utils.js";
class l extends a {
  constructor() {
    super(...arguments);
    s(this, "priority", 40);
    s(this, "incompatibleTokens", "*");
  }
  parse(r) {
    return n(r);
  }
  set(r, c, o) {
    return [p(r, o * 1e3), { timestampIsSet: !0 }];
  }
}
export {
  l as TimestampSecondsParser
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/parse/_lib/parsers/TimestampSecondsParser.js
// module id = 1437
// module chunks = 67